/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_Onboarding_Personal_Info_Personal_Info_TitleInputs */

const en_register_onboarding_personal_info_personal_info_title = /** @type {(inputs: Register_Onboarding_Personal_Info_Personal_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personal information`)
};

const de_register_onboarding_personal_info_personal_info_title = /** @type {(inputs: Register_Onboarding_Personal_Info_Personal_Info_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Persönliche Angaben`)
};

/**
* | output |
* | --- |
* | "Personal information" |
*
* @param {Register_Onboarding_Personal_Info_Personal_Info_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_onboarding_personal_info_personal_info_title = /** @type {((inputs?: Register_Onboarding_Personal_Info_Personal_Info_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_Onboarding_Personal_Info_Personal_Info_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_onboarding_personal_info_personal_info_title(inputs)
	return en_register_onboarding_personal_info_personal_info_title(inputs)
});